var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icons8-linkedin","d":"M22.816,6H9.032A3.036,3.036,0,0,0,6,9.032V22.816a3.036,3.036,0,0,0,3.032,3.032H22.816a3.036,3.036,0,0,0,3.032-3.032V9.032A3.036,3.036,0,0,0,22.816,6Zm-10.2,15.438a.551.551,0,0,1-.551.551H10.411a.551.551,0,0,1-.551-.551V14.27a.551.551,0,0,1,.551-.551h1.654a.551.551,0,0,1,.551.551Zm-1.378-8.822a1.378,1.378,0,1,1,1.378-1.378A1.378,1.378,0,0,1,11.238,12.616Zm10.751,8.822a.551.551,0,0,1-.551.551H19.784a.551.551,0,0,1-.551-.551V17.3a1.378,1.378,0,0,0-2.757,0v4.135a.551.551,0,0,1-.551.551H14.27a.551.551,0,0,1-.551-.551V14.27a.551.551,0,0,1,.551-.551h1.654a.551.551,0,0,1,.551.551v.3a3.3,3.3,0,0,1,5.514,2.458Z","transform":"translate(-6 -6)","fill":"#81e6d9"}));
}

Linkedin.defaultProps = {"width":"19.849","height":"19.849","viewBox":"0 0 19.849 19.849"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
